import { render, staticRenderFns } from "./EmailDialog.vue?vue&type=template&id=4e62c5bb&scoped=true"
import script from "./EmailDialog.vue?vue&type=script&lang=ts"
export * from "./EmailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e62c5bb",
  null
  
)

export default component.exports